<script setup lang="ts">
import { ButtonPrimaryAccented, ButtonSecondaryNeutral } from '~/features/ui-kit';
import SegmentControl from '~/features/ui-kit/radio/SegmentControl.vue';
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';

import { useDevToolbar } from '../business/form';
import { DevToolbarUiConfig } from './tabs';

const emits = defineEmits<{ (e: 'close', value: boolean): void }>();
const { reset, submit } = useDevToolbar();

const commitHash = useRuntimeConfig().public.COMMIT_HASH;

const currentTabOption = ref(DevToolbarUiConfig.tabsOptions[0].value);
const currentTabComponent = computed(() =>
  DevToolbarUiConfig.getTabByValue(currentTabOption.value)
);

onMounted(() => reset());

function onSave() {
  submit();
  emits('close', true);
}
</script>

<template>
  <MMPopupDefault class="dev-toolbar-modal" @close="$emit('close', false)">
    <template #header>
      <div class="dev-toolbar-modal__header">
        <MMText
          font="Title L/Semibold"
          font-mobile-or-tablet="Title S/Medium"
          class="dev-toolbar-modal__header__title"
        >
          <span>[{{ commitHash }}]</span>
        </MMText>

        <SegmentControl v-model="currentTabOption" :options="DevToolbarUiConfig.tabsOptions" />
      </div>
    </template>

    <div class="dev-toolbar-modal__body">
      <component :is="currentTabComponent" />
    </div>

    <template #footer>
      <div class="dev-toolbar-modal__footer">
        <ButtonSecondaryNeutral @click="$emit('close', false)">Отменить</ButtonSecondaryNeutral>
        <ButtonPrimaryAccented @click="onSave">Сохранить</ButtonPrimaryAccented>
      </div>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.dev-toolbar-modal
  width 650px
  height 100vh

  &__header
    display flex
    flex-direction column
    gap 8px
    padding-bottom 16px

    &__title
      display flex
      gap 16px
      @media (max-width $pre-laptop)
        flex-direction column
        gap 8px

  &__footer
    display flex
    gap 8px
    justify-content flex-end
    padding-top 16px

  &__body
    display flex
    flex-direction column
    gap 8px
</style>
